import React, { Component } from "react";
import "../../styles/Clan.css";
import CommonApis from "../../helper/common.api";
import ClanApis from "../../helper/clan.api";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { errorHandler } from "../../utils/common.utils";
import TeamApis from "../../helper/teams.api";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { trackEvent } from "../analytics/GoogleAnalyticsTrackEvents";
import { validateInGameId, getGameIdFormatHint } from "../../utils/ValidateInGameId.utils"; // Import the utility functions

class QuickTeamRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDisabled: false,
      loading: false,
      countryCodes: [],
      selectedGame: null,
      gameIdError: "",
    };

    this.commonApi = new CommonApis();
    this.clanApi = new ClanApis();
    this.teamApi = new TeamApis();
  }

  componentDidMount() {
    if (this.props.selectedGame) {
      this.setState({ selectedGame: this.props.selectedGame });
    }
    this.getCodes();

    // Track registration modal view
    trackEvent("tournament_registration_view", {
      tournament_id: this.props.tournamentDetails?._id,
      tournament_name: this.props.tournamentDetails?.name,
      game_name: this.props.tournamentDetails?.gameDetails?.name,
      competition_type: this.props.tournamentDetails?.competitionType,
    });
  }

  getCodes = () => {
    if (this.props.updateLoader) {
      this.props.updateLoader(true);
    }

    this.commonApi
      .getCountryCodes()
      .then(res => {
        if (this.props.updateLoader) {
          this.props.updateLoader(false);
        }
        this.setState({ countryCodes: res.data.result });
      })
      .catch(err => {
        if (this.props.updateLoader) {
          this.props.updateLoader(false);
        }
        errorHandler(err);
      });
  };

  handleCloseClick = () => {
    // Track modal close
    trackEvent("tournament_registration_close", {
      tournament_id: this.props.tournamentDetails?._id,
      game_name: this.props.tournamentDetails?.gameDetails?.name,
    });

    if (this.props.toggleQuickTeamRegister) {
      this.props.toggleQuickTeamRegister(false);
    }
  };

  onSubmit = values => {
    try {
      this.setState({
        isDisabled: true,
        loading: true,
      });

      // Track registration attempt
      trackEvent("tournament_registration_attempt", {
        tournament_id: this.props.tournamentDetails?._id,
        game_name: this.props.tournamentDetails?.gameDetails?.name,
        has_clan_name: !!values.clanName,
        has_team_name: !!values.teamName,
        has_in_game_id: !!values.inGameId,
        has_mobile: !!values.mobileNumber,
        country_code: values.countryCode,
      });

      if (this.props.updateLoader) {
        this.props.updateLoader(true);
      }

      const data = {
        clanName: values.clanName,
        teamName: values.teamName,
        tournamentId: this.props.tournamentDetails._id,
        inGameId: values.inGameId,
        inGameName: values.inGameName,
        mobileNo: {
          code: values.countryCode || "+91",
          number: values.mobileNumber || null,
        },
      };

      this.teamApi
        .createClanWithTeam(data)
        .then(res => {
          // Track successful registration
          trackEvent("tournament_registration_success", {
            tournament_id: this.props.tournamentDetails?._id,
            tournament_name: this.props.tournamentDetails?.name,
            game_name: this.props.tournamentDetails?.gameDetails?.name,
            clan_name: values.clanName,
            team_name: values.teamName,
            in_game_name: values.inGameName,
            country_code: values.countryCode,
          });

          toast.success("Clan and Team Created Successfully", 3000);

          this.setState({
            isDisabled: false,
            loading: false,
          });

          if (this.props.updateLoader) {
            this.props.updateLoader(false);
          }

          if (typeof this.props.onClanCreated === "function") {
            this.props.onClanCreated(res);
          } else {
            this.handleCloseClick();
          }
        })
        .catch(err => {
          // Track registration failure
          trackEvent("tournament_registration_failure", {
            tournament_id: this.props.tournamentDetails?._id,
            game_name: this.props.tournamentDetails?.gameDetails?.name,
            error_type: err.response?.data?.message || "unknown_error",
            clan_name: values.clanName,
            team_name: values.teamName,
          });

          this.setState({
            isDisabled: false,
            loading: false,
          });

          if (this.props.updateLoader) {
            this.props.updateLoader(false);
          }

          errorHandler(err);
        });
    } catch (error) {
      // Track registration error
      trackEvent("tournament_registration_error", {
        tournament_id: this.props.tournamentDetails?._id,
        game_name: this.props.tournamentDetails?.gameDetails?.name,
        error_type: "form_submission_error",
      });

      this.setState({
        isDisabled: false,
        loading: false,
      });

      if (this.props.updateLoader) {
        this.props.updateLoader(false);
      }

      toast.error("An error occurred while submitting the form", 3000);
    }
  };

  validateGameId = value => {
    const gameName = this.props.tournamentDetails?.gameDetails?.name;
    if (!gameName) return "";

    const error = validateInGameId(value, gameName);

    // Track game ID validation
    if (error) {
      trackEvent("tournament_registration_gameid_validation", {
        tournament_id: this.props.tournamentDetails?._id,
        game_name: gameName,
        error_type: error,
      });
    }

    this.setState({ gameIdError: error });
    return error;
  };

  render() {
    const { loading, isDisabled, countryCodes } = this.state;
    const { selectedGame } = this.props;

    return (
      <div className="create-clan-page p-4">
        <div className="row">
          <div className="col-lg-12 col-md-12 pe-md-4">
            <div className="d-flex flex-column px-3">
              <h5 className="text-heading fs-18 fw-bold text-white text-center mb-2">
                Quick Register Clan & Team
              </h5>
              <p className="text-center text-white fs-14 fw-500 mb-3">
                Ready to dominate? Create your clan, build your squad, and battle for glory!
              </p>
              <IoIosCloseCircleOutline
                className="close-icon position-absolute"
                style={{ right: "25px", top: "20px" }}
                onClick={this.handleCloseClick}
              />
            </div>

            <Formik
              initialValues={{
                clanName: "",
                teamName: "",
                gameId: selectedGame?._id || "",
                inGameId: "",
                inGameName: "",
                countryCode: "+91",
                mobileNumber: "",
              }}
              validationSchema={Yup.object({
                clanName: Yup.string()
                  .required("Clan Name is Required")
                  .max(50, "Max 50 characters")
                  .matches(/(\d|\w)/, "Special characters are not allowed."),
                teamName: Yup.string()
                  .required("Team Name is Required")
                  .max(50, "Max 50 characters"),
                inGameId: Yup.string()
                  .required("In-Game ID is Required")
                  .max(200, "Max 200 characters"),
                inGameName: Yup.string()
                  .required("In-Game Name is Required")
                  .max(50, "Max 50 characters"),
                // .matches(/^[a-zA-Z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/, "In-Game Name can contain letters, numbers, spaces and special characters"),
                countryCode: Yup.string().required("Country code is required"),
                mobileNumber: Yup.string()
                  .required("Mobile Number is required")
                  .max(10, "Should be 10 digit")
                  .min(10, "Should be 10 digit")
                  .test("is-empty-or-valid", "Mobile number is invalid", function (value) {
                    const phoneRegex = /^[0-9]{10}$/;
                    return phoneRegex.test(value);
                  })
                  .test("no-spaces", "Mobile number should not contain spaces", function (value) {
                    if (!value) return true;
                    return !/\s/.test(value);
                  }),
              })}
              onSubmit={(values, { setSubmitting }) => {
                this.onSubmit(values);
                setSubmitting(false);
              }}
            >
              {({ values, setFieldValue, isSubmitting, isValid }) => (
                <Form className="create-clan-form mt-3" autoComplete="off">
                  <div className="section-title mb-3">
                    <h6 className="text-white fw-bold">Clan & Team Information</h6>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="clanName" className="fs-16 fw-600 text-white mb-1">
                      Clan Name *
                    </label>
                    <Field
                      id="clanName"
                      name="clanName"
                      type="text"
                      className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white height-45"
                      placeholder="e.g., Phoenix Squad, Dragon Warriors"
                    />
                    <ErrorMessage component="span" name="clanName" className="error-msg" />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="teamName" className="fs-16 fw-600 text-white mb-1">
                      Team Name *
                    </label>
                    <Field
                      id="teamName"
                      name="teamName"
                      type="text"
                      className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white height-45"
                      placeholder="e.g., Alpha Team, Nighthawks, Thunderbolts"
                    />
                    <ErrorMessage component="span" name="teamName" className="error-msg" />
                  </div>

                  <div className="section-title mb-3 mt-4">
                    <h6 className="text-white fw-bold">Player Information</h6>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="inGameName" className="fs-16 fw-600 text-white mb-1">
                      In-Game Name *
                    </label>
                    <Field
                      id="inGameName"
                      name="inGameName"
                      type="text"
                      className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white height-45"
                      placeholder="e.g., NinjaSniper, Frag_Master"
                    />
                    <ErrorMessage component="span" name="inGameName" className="error-msg" />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="inGameId" className="fs-16 fw-600 text-white mb-1">
                      In-Game ID *
                      {selectedGame && (
                        <small className="ms-2 text-muted">
                          {selectedGame?.name && getGameIdFormatHint(selectedGame.name)}
                        </small>
                      )}
                    </label>
                    <Field
                      id="inGameId"
                      name="inGameId"
                      type="text"
                      className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white height-45"
                      placeholder="Enter your in-game ID"
                      validate={this.validateGameId}
                    />
                    <ErrorMessage component="span" name="inGameId" className="error-msg" />
                  </div>

                  <div className="row mb-3">
                    <div className="col-4">
                      <label htmlFor="countryCode" className="fs-16 fw-600 text-white mb-1">
                        Country Code
                      </label>
                      <Field
                        id="countryCode"
                        name="countryCode"
                        as="select"
                        className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white height-45"
                      >
                        {countryCodes.length > 0 ? (
                          countryCodes.map((el, i) => (
                            <option value={el.code} key={i}>
                              {`${el.code} ${el.name}`}
                            </option>
                          ))
                        ) : (
                          <option value="+91">+91 India</option>
                        )}
                      </Field>
                      <ErrorMessage component="span" name="countryCode" className="error-msg" />
                    </div>
                    <div className="col-8">
                      <label htmlFor="mobileNumber" className="fs-16 fw-600 text-white mb-1">
                        Mobile Number
                      </label>
                      <Field
                        id="mobileNumber"
                        name="mobileNumber"
                        type="text"
                        className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white height-45"
                        placeholder="Enter your mobile number"
                        maxLength={10}
                      />
                      <ErrorMessage component="span" name="mobileNumber" className="error-msg" />
                      <small className="red-50 fs-12">Numbers only, 10 digits with no spaces</small>
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={isDisabled || loading || isSubmitting || !isValid}
                    className="white-flat-btn d-block fw-bold py-2 px-5 m-auto mt-4"
                  >
                    {isDisabled ? "Creating..." : "Create Clan & Team"}
                  </button>

                  <p className="text-center text-white fs-12 fw-500 mt-3">
                    Once created, invite your teammates to join the battle and claim your victory!
                  </p>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    );
  }
}

export default QuickTeamRegister;
